export default "__VITE_ASSET__Dpr2HATA__"